var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5563 22.9273C23.514 23.9696 21.8241 23.9696 20.7817 22.9273C19.7394 21.8849 19.7394 20.195 20.7817 19.1526L23.1409 16.7935C24.1357 15.7986 25.7206 15.7533 26.7692 16.6576M26.4437 13.4907C27.486 12.4484 29.1759 12.4484 30.2183 13.4907C31.2606 14.5331 31.2606 16.223 30.2183 17.2653L27.8591 19.6245C26.8643 20.6194 25.2794 20.6647 24.2308 19.7603",
    stroke: "url(#paint0_linear_2501_2578)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 12.709C17.2126 12.709 15.5689 12.709 14.4626 13.6169C14.26 13.7831 14.0742 13.9689 13.908 14.1715C13.0001 15.2778 13.0001 16.9215 13 20.2088L13 22.7089C13 26.4802 13 28.3658 14.1715 29.5374C15.3431 30.709 17.2287 30.709 21 30.709H23.4999C26.7874 30.709 28.4311 30.709 29.5375 29.801C29.74 29.6348 29.9257 29.4491 30.092 29.2466C30.9999 28.1402 30.9999 26.4965 30.9999 23.209",
    stroke: "url(#paint1_linear_2501_2578)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2501_2578",
    x1: 20,
    y1: 18.209,
    x2: 31,
    y2: 18.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2501_2578",
    x1: 13,
    y1: 21.709,
    x2: 30.9999,
    y2: 21.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.6b82d6a3fc4c664ae07ca93c1811ea4c.svg";
export { ForwardRef as ReactComponent };